import React from 'react';
import { Box } from '@mui/material';
export default function WildsLaunchContainer({ children }: any) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        flex: '1 1 auto',
        boxSizing: 'border-box',
        paddingInline: '1.25rem',
        marginInline: 'auto',
        maxWidth: {
          xs: '100%',
          sm: '600px',
          md: '960px',
          lg: '1240px',
          xl: '1400px',
        },
        mx: 'auto',
      }}
    >
      {children}
    </Box>
  );
}
